<div class="tw-flex tw-flex-col">
    <mat-chip
        class="tw-w-fit tw-self-center tw-m-2"
        *ngIf="isPreviousMessageFromOtherDay()"
        color="accent"
        selected
        removable="false"
    >
        {{ getDateDivider(msg) | date: "short" }}
    </mat-chip>

    <mat-card
        class="tw-shadow-none tw-bg-transparent"
        [ngClass]="[
            msg.role !== USER_ROLE ? 'tw-self-start' : 'tw-self-end',
            !isPredecessorSameAuthor() ? 'tw-py-0' : 'tw-py-0'
        ]"
    >
        <!-- Message Header -->
        <mat-card-header
            class="tw-justify-start tw-mb-2 tw-items-center"
            [ngClass]="[
                msg.role !== USER_ROLE ? 'tw-flex-row' : 'tw-flex-row-reverse'
            ]"
        >
            @if (!localUser.photo || msg.role === AI_ASSISTANT_ROLE) {
                <mat-icon
                    class="tw-size-6 tw-border-solid tw-border-2 tw-rounded-full tw-border-m3OnSurfaceVariant"
                >
                    account_circle
                </mat-icon>
            } @else {
                <img
                    class="tw-size-7 tw-border-solid tw-rounded-full tw-border-2 tw-border-m3OnSurfaceVariant"
                    [src]="localUser.photo"
                />
            }
            <div
                class="tw-text-[14px] tw-font-semibold tw-tracking-[1px]"
                [ngClass]="[
                    msg.role !== USER_ROLE
                        ? 'tw-ml-2 tw-mr-[10px]'
                        : 'tw-ml-[10px] tw-mr-2'
                ]"
            >
                {{ getUserName(msg.role) | titlecase }}
            </div>
        </mat-card-header>
        <mat-card-content class="tw-inline-flex tw-flex-col">
            <!-- Message content-->
            <mat-card
                class="tw-min-w-[150px] tw-max-w-full tw-mb-2 tw-px-3 tw-pt-4 tw-text-white"
                [ngClass]="[
                    msg.role !== USER_ROLE ? 'message-user' : 'message-ai'
                ]"
            >
                @if (msg.role !== USER_ROLE) {
                    <div
                        class="tw-absolute tw-top-[2px] tw-left-[4px] tw-text-[12px] tw-opacity-60 tw-ml-2"
                    >
                        {{ getCreatedDate(msg) | date: "short" }}
                    </div>
                } @else {
                    <div
                        class="tw-absolute tw-top-[2px] tw-right-[4px] tw-text-[12px] tw-opacity-60 tw-mr-2"
                    >
                        {{ getCreatedDate(msg) | date: "short" }}
                    </div>
                }
                <div class="message-bubble tw-break-words">
                    <markdown
                        id="mk-text"
                        [data]="msg.contentItems[0].text"
                    ></markdown>
                </div>
            </mat-card>

            <mat-chip-list
                class="tw-flex"
                [ngClass]="[
                    msg.role !== USER_ROLE
                        ? 'tw-justify-end'
                        : 'tw-justify-start'
                ]"
            >
                <mat-chip *ngFor="let attachment of msg.attachments">
                    <mat-icon>insert_drive_file</mat-icon>
                    {{ attachment.name }}
                </mat-chip>
            </mat-chip-list>
        </mat-card-content>
    </mat-card>
</div>
